<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_AddOverseaWarehouse')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div class="app-main-content railwayStation">
      <div class="grid-view">
        <div class="main-content">
          <div class="operations">
            <el-form
              :inline="true"
              label-width="50px"
              label-position="left"
              @submit.native.prevent="filter.pageNum=1;toQuery()"
            >
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('common.btn.query')">
                  <el-input
                    v-model="filter.likeName"
                    :no="'searchInput'"
                    :placeholder="$t('common.tips.fuzzySearch')"
                    style="width:310px"
                  />
                </el-form-item>
                <el-button size="mini" type="primary" :no="'query'" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}
                </el-button>
              </div>
            </el-form>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="girdParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;min-height: 320px"
              :show-side-bar="false"
            />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" :no="'add'" @click="addHandler">{{ $t('common.btn.add') }}</el-button>
      <el-button :no="'cancel'" @click="visible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getFbaAndOverseaWarehouseList, batchSave } from '@/api/basicData/overseaWarehouse'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'SelectOverseaWarehouseTemplateListDialog',
  props: {
    visible: { type: Boolean, required: true },
    tenantId: { type: Number, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {
        tenantId: 0,
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_AlreadyAddedOrNot'),
          field: 'isExist',
          width: 200,
          cellRenderer: params => {
            const iconName = !params.value ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.value ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.warehouseCode'),
          field: 'warehouseCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.country'),
          field: 'countryCode',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'name')
          }
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.province'),
          field: 'province',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.city'),
          field: 'cityName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.zipCode'),
          field: 'zipCode',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.address'),
          field: 'address1',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.ifFba'),
          field: 'ifFba',
          width: 200,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.entryRequirements'),
          field: 'entryRequirements',
          width: 200
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toQuery() {
      const loading = getLoading()
      this.filter.tenantId = this.tenantId
      getFbaAndOverseaWarehouseList(this.filter).then(res => {
        const fbaWarehouseList = res.data.fbaWarehouseList
        const overseaWarehouseList = res.data.overseaWarehouseList
        for (const c of fbaWarehouseList) {
          c.isExist = false
        }
        for (const c1 of fbaWarehouseList) {
          for (const c2 of overseaWarehouseList) {
            if (c1.warehouseCode === c2.warehouseCode) {
              c1.isExist = true
              break
            }
          }
        }
        this.rowData = fbaWarehouseList
      }).finally(() => loading.close())
    },
    addHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.unSelectFbaWarehouse'))
        return
      }
      const saveList = []
      for (const p of rows) {
        if (p.isExist) {
          this.$message.warning(StrUtils.substitute(this.$t('baseInfo.overseaWarehouse.msg.duplicateAddition'), p.warehouseCode))
          return
        } else {
          const _overseaWarehouse = {}
          _overseaWarehouse.tenantId = this.tenantId
          _overseaWarehouse.warehouseCode = p.warehouseCode
          _overseaWarehouse.countryCode = p.countryCode
          _overseaWarehouse.province = p.province
          _overseaWarehouse.cityCode = p.cityCode
          _overseaWarehouse.cityName = p.cityName
          _overseaWarehouse.zipCode = p.zipCode
          _overseaWarehouse.ifFba = p.ifFba
          _overseaWarehouse.address1 = p.address1
          _overseaWarehouse.entryRequirements = p.entryRequirements
          saveList.push(_overseaWarehouse)
        }
      }
      const loading = getLoading()
      batchSave(saveList).then(res => {
        syncSpecificBasicData(basicCacheKeys.basic_data_OverseaWarehouse)
        this.$emit('addCallBack', res.data)
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.$emit('close')
      }).finally(() => {
        loading.close()
        this.toQuery()
      })
    }
  }
}
</script>

<style scoped>

</style>
